/** Map defaults — centered on Bishkek */
export const MAP_CENTER = [74.5698, 42.8746]; // [lng, lat]
export const MAP_ZOOM = 12;
export const MAP_MIN_ZOOM = 10;
export const MAP_MAX_ZOOM = 18;

/** Map bounds — roughly Bishkek city limits */
export const MAP_BOUNDS = [
  [74.35, 42.78], // SW
  [74.78, 42.96], // NE
];

/** Map style */
export const MAP_STYLE = 'mapbox://styles/mapbox/dark-v11';

/** Cluster settings */
export const CLUSTER_RADIUS = 50;
export const CLUSTER_MAX_ZOOM = 14;

/** Status options */
export const STATUSES = {
  open: { name: 'Открыто', color: '#ef4444' },
  in_progress: { name: 'В процессе', color: '#eab308' },
  resolved: { name: 'Решено', color: '#22c55e' },
};

/** Max image size in bytes (5MB) */
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

/** Accepted image types */
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
